// extracted by mini-css-extract-plugin
export default {"navigation":"Y1XTUQbn3NRV5n87Q1Og","items":"pHD0NJham73gp2zciHej","footer":"M70v2bnv7fzmr_G4dlXd"};